/**
 * DeveloperDetails — collapsible "raw diagnostics" panel (Iter-32 Phase 4).
 *
 * Renders only if `text` is a non-empty string. Hidden by default; the
 * customer sees the plain-language `check.detail` and can opt in to the
 * technical details (raw HTTP status, error kind, probe outcome).
 *
 * This is the promised "customers see plain-language, developers see raw"
 * split from the failure-classification spec (Iter-32 Phase 1 §5).
 */
import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

export default function DeveloperDetails({ text, testIdSuffix = "" }) {
  const [open, setOpen] = useState(false);
  const t = (text || "").trim();
  if (!t) return null;
  return (
    <div className="mt-2" data-testid={`developer-details${testIdSuffix ? `-${testIdSuffix}` : ""}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1 text-[10px] font-mono uppercase tracking-wider text-charcoal-400 hover:text-charcoal-700 transition-colors"
        data-testid={`developer-details-toggle${testIdSuffix ? `-${testIdSuffix}` : ""}`}
      >
        {open ? <ChevronDown className="w-3 h-3" /> : <ChevronRight className="w-3 h-3" />}
        Technical details
      </button>
      {open && (
        <pre
          className="mt-1.5 px-2.5 py-1.5 rounded-md bg-charcoal-50 text-[10.5px] font-mono text-charcoal-600 whitespace-pre-wrap break-words border border-black/5"
          data-testid={`developer-details-body${testIdSuffix ? `-${testIdSuffix}` : ""}`}
        >
          {t}
        </pre>
      )}
    </div>
  );
}
